import React from "react";
import { PencilIcon } from "@heroicons/react/24/solid";
import { MerchantButton, EmailInput } from "@components";

const KlarnaEmailInput = ({
  klarnaEmailAddress,
  setKlarnaEmailAddress,
  klarnaEmailError,
  setKlarnaEmailError,
  klarnaEmailAddressConfirmed,
  setKlarnaEmailAddressConfirmed,
  validateEmailAndConfirm,
  merchant,
  merchantColourSet,
}) => {
  return (
    <div className="flex flex-col gap-2 py-5 px-4 bg-zinc-100 rounded-xl border border-zinc-300 relative">
      <div className="flex flex-col gap-4 items-center">
        <div className="flex gap-2 items-center w-full">
          {klarnaEmailAddressConfirmed ? (
            <span className="text-sm text-zinc-900 w-full">
              {klarnaEmailAddress}
            </span>
          ) : (
            <EmailInput
              placeholder="Enter your email address"
              value={klarnaEmailAddress}
              className="text-base sm:text-sm"
              onChange={(e) => {
                setKlarnaEmailAddress(e.target.value);
                if (klarnaEmailError) {
                  setKlarnaEmailError("");
                }
              }}
              errors={klarnaEmailError}
            />
          )}
          {klarnaEmailAddressConfirmed && (
            <button
              className="text-sm text-blue-900 hover:text-primary-dark cursor-pointer flex items-center gap-1"
              style={{
                color: merchantColourSet?.button || "white",
              }}
              onClick={() => setKlarnaEmailAddressConfirmed(false)}
            >
              <PencilIcon
                className="w-4 h-4"
                style={{
                  color: merchantColourSet?.button || "white",
                }}
              />
              Edit
            </button>
          )}
        </div>

        {!klarnaEmailAddressConfirmed && klarnaEmailError && (
          <p className="w-full text-sm text-red-600 mt-1">{klarnaEmailError}</p>
        )}

        {!klarnaEmailAddressConfirmed && (
          <MerchantButton
            onClick={validateEmailAndConfirm}
            merchant={merchant}
            className="w-full rounded-md"
          >
            Confirm
          </MerchantButton>
        )}
      </div>
    </div>
  );
};

export default KlarnaEmailInput;
